module.exports = __webpack_public_path__ + "static/q8_x-dcb489fb9fb2104d58da8b4dc275cbfb.png";